export default {
  pageTitle: 'About',
};
